// src/components/PropertySelector.jsx
import React from 'react';

export default function PropertySelector({ properties, selected, onSelect }) {
  if (!properties || properties.length === 0) return null;

  return (
    <select
      value={selected?.id || ''}
      onChange={(e) => {
        const prop = properties.find(p => p.id === e.target.value);
        onSelect(prop);
      }}
      className="w-full max-w-full bg-white border border-gray-300 rounded-xl px-4 py-2.5 text-base sm:w-auto sm:text-sm font-medium text-gray-700 focus:ring-2 focus:ring-tenafi-green focus:border-tenafi-green outline-none transition-all"
    >
      {properties.map(prop => (
        <option key={prop.id} value={prop.id}>
          {prop.name} ({prop.units || '?'} units)
        </option>
      ))}
    </select>
  );
}
